/**
 * 银联商旅相关
 */

import {localget} from './storage'


export function isYlsl() {
  const param = localget('query_param')
  if (!param) {
    return false
  } else {
    return 'unionpay' === param.thirdFrom
  }
}

